import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useGameParams from '~/client/components/Game/hooks/useGameParams';
import useGameCardSize from '~/client/shared/game/GameCard/useGameCardSize';

const usePlaylistGames = () => {
  const { game } = useGameContext();
  const { width, height } = useGameCardSize();
  const { categoryHandle = '' } = useGameParams();
  const menuItem = getMenuItem(categoryHandle);
  const theme = game?.themes?.edges?.[0]?.node?.handle;
  const href = {
    menuItem: `/categories/${menuItem}`,
    theme: `/themes/${theme}`,
  };
  return { menuItem, href, game, width, height, theme };
};

const getMenuItem = (categoryHandle: string) =>
  categoryHandle.replace('bombay-club', 'live');

export default usePlaylistGames;
